import type CalendarFormPerfStore from './schema/CalendarFormPerfStore';
import { ObservableMap } from 'mobx';
import type { PerformanceDatapoint } from 'owa-analytics';
import { createStore } from 'satcheljs';

const defaultCalendarFormPerfStore: CalendarFormPerfStore = {
    formIdToDatapointMap: new ObservableMap<string, PerformanceDatapoint>(),
};

export const getStore = createStore<CalendarFormPerfStore>(
    'calendarFormPerfStore',
    defaultCalendarFormPerfStore
);

export default getStore;
